export function findClosestShipments(inputValue, parameter, shipments) {
    shipments = JSON.parse(JSON.stringify(shipments))
    if(!inputValue) {
        return shipments
    }

    inputValue = inputValue.trim().toLowerCase()
    
    if(!parameter) {
        return shipments
    }

    let filteredShipments = []

    for(let shipment of shipments) {
        if(shipment[parameter] === "" || shipment[parameter] === null || shipment[parameter] === undefined) {
            continue
        }

        let indexOfValueInShipmentParameter = getIndexOfSubstring(inputValue, shipment[parameter].toString())
        
        if (indexOfValueInShipmentParameter === -1) {
            continue
        }
    

        let flag = false
        for(let j in filteredShipments) {
            if(indexOfValueInShipmentParameter < filteredShipments[j][1]) {
                filteredShipments.splice(j, 0, [shipment, indexOfValueInShipmentParameter])
                flag = true
                break
            }
        }
        if(!flag) {
            filteredShipments.push([shipment, indexOfValueInShipmentParameter])
        }
    }

    let res = []
    for(let i in filteredShipments) {
        res.push(filteredShipments[i][0])
    }

    return res
}

function getIndexOfSubstring(substring, str) {
    return str.toLowerCase().indexOf(substring)
}